module.exports = __webpack_public_path__ + "img/content_bg4.3f504c7.png";